import { startTransition, useState, type ReactNode } from "react";
import { vars } from "@pack-it-up/ui-web";
import { SearchIcon } from "../../app/icons.js";

// Search state for a topbar search box: `query` drives the input, `filtered` is the
// normalized term the list filters on. The filter update is a transition so typing
// stays responsive while a large grid re-renders.
export const useSearch = (): { query: string; filtered: string; onChange: (val: string) => void } => {
  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState("");
  const onChange = (val: string): void => {
    setQuery(val);
    startTransition(() => setFiltered(val.trim().toLowerCase()));
  };
  return { query, filtered, onChange };
};

// Case-insensitive name match against a normalized search term (see `useSearch`).
export const matchesName = (name: string, filtered: string): boolean => name.toLowerCase().includes(filtered);

// The topbar search box — shared by Home, My Trips and My Templates.
export const SearchBox = ({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (val: string) => void;
  placeholder: string;
}): ReactNode => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: vars.space.sm,
      width: "240px",
      backgroundColor: vars.color.surfaceRaised,
      border: `1px solid ${vars.color.border}`,
      borderRadius: vars.radius.md,
      padding: `${vars.space.xs} ${vars.space.md}`,
      flexShrink: 0,
    }}
  >
    <span style={{ color: vars.color.textMuted, display: "flex", flexShrink: 0 }}>{SearchIcon()}</span>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder.replace(/…$/, "")}
      style={{
        flex: 1,
        border: "none",
        outline: "none",
        background: "transparent",
        color: vars.color.text,
        fontFamily: vars.font.body,
        fontSize: vars.font.sizeSm,
        minWidth: 0,
      }}
    />
  </div>
);
